// src/services/favoriteList.service.js
import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_URL;

class FavoriteListService {
  getFavoriteLists() {
    return axios.get(`${API_URL}favorite-lists`, { headers: authHeader() });
  }
  addFavoriteList(data) {
    return axios.post(`${API_URL}favorite-lists`, data, {
      headers: authHeader(),
    });
  }
  updateFavoriteList(id, data) {
    return axios.put(`${API_URL}favorite-lists/${id}`, data, {
      headers: authHeader(),
    });
  }
  removeFavoriteList(id) {
    return axios.delete(`${API_URL}favorite-lists/${id}`, {
      headers: authHeader(),
    });
  }

  // addListingToList(listId, listingId) {
  //   return axios.post(
  //     `${API_URL}favorite-lists/${listId}/favorites`,
  //     { listing_id: listingId },
  //     { headers: authHeader() }
  //   );
  // }

  getFavoriteList(id) {
    return axios.get(`${API_URL}favorite-lists/${id}`, {
      headers: authHeader(),
    });
  }

  addListingToList(listId, listingId) {
    return axios.post(
      `${API_URL}favorite-lists/${listId}/favorites`,
      { listing_id: listingId },
      { headers: authHeader() }
    );
  }
}

export default new FavoriteListService();
